import { AddressMonitoringListResponse, MonitoringAddress } from '@/api';
import { AddressMonitoringData, MonitoringAddressItem } from '@/redux/models';

const addressItem = (data: MonitoringAddress): MonitoringAddressItem => {
  return {
    id: Number(data.id),
    create: data.create,
    address: data.address,
    asset: data.asset,
    tmacnt_id: Number(data.tmacnt_id),
    next_check_time: data.next_check_time,
    status: Number(data.status),
    riskscore: Number(data.riskscore),
    has_blacklist_flag: Boolean(Number(data.has_blacklist_flag)),
    type: Number(data.type),
    valid_until: data.valid_until,
  };
};

const monitoringHistory = (
  response: AddressMonitoringListResponse,
): AddressMonitoringData => {
  const { data } = response;
  const list = (data.data as MonitoringAddress[]) || [];

  const mappedData: AddressMonitoringData = {
    result: data.result,
    pageLimit: data.pageLimit,
    totalCount: data.totalCount,
    items: list.map(addressItem),
  };

  return mappedData;
};

export { monitoringHistory, addressItem };
